export function calculateEndQuantity(
  mustBuy: number,
  endQuantity: number,
): number {
  return Math.floor(endQuantity / mustBuy) * mustBuy;
}

export function getEndQuantity(mustBuy: number, endQuantity: number): number {
  return mustBuy ? calculateEndQuantity(mustBuy, endQuantity) : endQuantity;
}

export function formatQuantityDiscountData(
  mustBuy: number,
  startQuantity: number,
  endQuantity?: number,
) {
  // The check for startQuantity is greater then endQuantity is here because the tooling doesn't have any error handling for this so we have to check it on the front-end.
  if (!endQuantity || startQuantity > endQuantity) {
    return `${startQuantity}+`;
  }

  if (startQuantity === endQuantity) {
    return `${startQuantity}`;
  }

  // This formats the start quantity and end quantity to be a range
  return `${startQuantity} - ${getEndQuantity(mustBuy, endQuantity)}`;
}
